/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import { ConvertDatesToStrings } from '@itk/typescript-utils'
import type { Model_CustomerPortalContactGet } from '../models/Model_CustomerPortalContactGet';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class CustomerPortalService {
    /**
     * @returns Model_CustomerPortalContactGet Success
     * @throws ApiError
     */
    public static getApiV1CustomerportalContact(): CancelablePromise<Model_CustomerPortalContactGet> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/customerportal/contact',
        });
    }
    /**
     * @param requestBody
     * @returns string Success
     * @throws ApiError
     */
    public static postApiV1CustomerportalEmployeePictureList(
        requestBody?: ConvertDatesToStrings<Array<string>>,
    ): CancelablePromise<Record<string, string>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/customerportal/employeePictureList',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
